import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { getBlogPosts } from '../lib/api';
import PageHeader from '../components/common/PageHeader';
import Loading from '../components/common/Loading';

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const data = await getBlogPosts({ published: true });
        setBlogs(data || []);
      } catch (error) {
        console.error('Error fetching blogs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const stripAndTruncateHtml = (html, maxLength = 150) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const text = tmp.textContent || tmp.innerText || '';

    if (text.length <= maxLength) return text;
    return `${text.substring(0, maxLength).trim()}...`;
  };

  if (loading) {
    return <Loading message="Blog yazıları yükleniyor..." />;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-gray-50"
    >
      <PageHeader
        title="Blog Yazıları"
        description="En son haberler, güncellemeler ve bilgilendirici içerikler"
        backgroundImage="/images/hero-bg.jpg"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogs.map((blog) => (
            <Link
              key={blog.id}
              to={`/blogs/${blog.slug}`}
              className="group block bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              {blog.image_url && (
                <div className="aspect-w-16 aspect-h-9">
                  <img src={blog.image_url} alt={blog.title} className="w-full h-full object-cover" />
                </div>
              )}
              <div className="p-6">
                <h2 className="text-xl font-semibold text-gray-900 group-hover:text-[#dbc582] transition-colors duration-300">
                  {blog.title}
                </h2>
                <p className="mt-2 text-gray-600 line-clamp-3">
                  {stripAndTruncateHtml(blog.content)}
                </p>
                <div className="mt-4 text-sm text-gray-500">
                  {new Date(blog.created_at).toLocaleDateString('tr-TR')}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default BlogList;
